import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EventsService} from './events/events.service';
import {PipeSahredModule} from './Pipes/pipe-shared.module';
import {LoadingIndicatorModule} from './loading-indicator/loading-indicator.module';
import {EventsModule} from './events/events.module';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MomentModule} from 'angular2-moment';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NgxPaginationModule} from 'ngx-pagination';
import {FacebookModule, FacebookService} from 'ngx-facebook';
import {routing} from './routing';
import {AppComponent} from './app.component';
import {GlobalService} from './global.service';
import {HttpClientModule} from '@angular/common/http';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ViewMapComponent} from './Dialogs/view-map/view-map.component';
import {SimpleNotificationsModule, NotificationsService} from 'angular2-notifications';
import {ChristmasComponent} from './events/events-templates/christmas/christmas.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DashboardLoginComponent} from './dashboard-login/dashboard-login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SidebarComponent} from './sidebar/sidebar.component';
import {SidebarDirective} from './sidebar/sidebar.directive';
import {SortPipe} from './Pipes/sort.pipe';
import {ShawarmerCitiesComponent} from './events/events-templates/shawarmer/shawarmer-cities/shawarmer-cities.component';
import {EventDialogComponent} from './Dialogs/event-dialog/event-dialog.component';

const material_comp = [ViewMapComponent, EventDialogComponent];

@NgModule({
  declarations: [
    AppComponent,
    material_comp,
    ChristmasComponent,
    DashboardComponent,
    DashboardLoginComponent,
    SidebarComponent,
    SidebarDirective,
    SortPipe,
    ShawarmerCitiesComponent,
  ],
  entryComponents: [
    material_comp
  ],
  imports: [
    BrowserAnimationsModule,
    EventsModule,
    PerfectScrollbarModule,
    SimpleNotificationsModule.forRoot(),
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    PipeSahredModule,
    LoadingIndicatorModule,
    FacebookModule.forRoot(),
    NgxPaginationModule,
    MomentModule,
    TooltipModule.forRoot(),
    MatTabsModule,
    MatMenuModule,
    MatTooltipModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    CommonModule,
    routing,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatChipsModule,
  ],
  providers: [EventsService, GlobalService, NotificationsService, FacebookService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
